import { Fragment } from 'react'

import { PDF_VIEWER_ALL_TOOLS } from '../PdfViewer.constants'

import {
  PDF_VIEWER_TOOLBAR_END_TOOLS,
  PDF_VIEWER_TOOLBAR_GROUPS,
} from './PdfViewerToolbar.constants'
import {
  getPdfViewerEnabledToolGroups,
  getPdfViewerEnabledTools,
} from './PdfViewerToolbar.utils'
import { PDF_VIEWER_TOOLBAR_TOOL_COMPONENT_BY_TOOL } from './PdfViewerToolbarTools'

import * as styles from './PdfViewerToolbar.module.css'

function PdfViewerToolbar({ tools = PDF_VIEWER_ALL_TOOLS, ...toolProps }) {
  const groups = getPdfViewerEnabledToolGroups({
    groups: PDF_VIEWER_TOOLBAR_GROUPS,
    tools,
  })

  const endTools = getPdfViewerEnabledTools({
    toolbarTools: PDF_VIEWER_TOOLBAR_END_TOOLS,
    tools,
  })

  function renderTool(tool) {
    const Tool = PDF_VIEWER_TOOLBAR_TOOL_COMPONENT_BY_TOOL[tool]

    return <Tool {...toolProps} key={tool} />
  }

  return groups.length > 0 || endTools.length > 0 ? (
    <div className={styles.PdfViewerToolbar}>
      <div className={styles.tools}>
        {groups.map((group, groupIndex) => (
          <Fragment key={group.id}>
            {groupIndex > 0 ? <span className={styles.divider} /> : null}
            {group.tools.map(renderTool)}
          </Fragment>
        ))}
      </div>
      <div className={styles.tools}>{endTools.map(renderTool)}</div>
    </div>
  ) : null
}

export default PdfViewerToolbar
